function osCheck() {
  var _p = window.navigator.platform

  if (_p === 'Win32' || _p === 'Windows') {
    return 'windows'
  }

  if (_p === 'Mac68K' || _p === 'MacPPC' || _p === 'Macintosh' || _p === 'MacIntel') {
    return 'mac'
  }

  return 'other'
}

function browserCheck() {
  var Sys = {}
  var ua = navigator.userAgent.toLowerCase()
  var s

  if (ua.match(/rv:([\d.]+)/)) {
    s = ua.match(/rv:([\d.]+)/)
    Sys.ie = s[1]
  } else if (ua.match(/msie ([\d.]+)/)) {
    s = ua.match(/msie ([\d.]+)/)
    Sys.ie = s[1]
  } else if (ua.match(/trident\/([\d.]+)/)) {
    s = ua.match(/trident\/([\d.]+)/)
    Sys.ie = s[1]
  } else if (ua.match(/firefox\/([\d.]+)/)) {
    s = ua.match(/firefox\/([\d.]+)/)
    Sys.firefox = s[1]
  } else if (ua.match(/chrome\/([\d.]+)/)) {
    s = ua.match(/chrome\/([\d.]+)/)
    Sys.chrome = s[1]
  } else if (ua.match(/opera.([\d.]+)/)) {
    s = ua.match(/opera.([\d.]+)/)
    Sys.opera = s[1]
  } else if (ua.match(/version\/([\d.]+).*safari/)) {
    s = ua.match(/version\/([\d.]+).*safari/)
    Sys.safari = s[1]
  }

  // 以下进行测试

  if (Sys.ie) {
    Sys.name = 'IE'
    Sys.version = Sys.ie
  }
  if (Sys.firefox) {
    Sys.name = 'Firefox'
    Sys.version = Sys.firefox
  }
  if (Sys.chrome) {
    Sys.name = 'Chrome'
    Sys.version = Sys.chrome
  }
  if (Sys.opera) {
    Sys.name = 'Opera'
    Sys.version = Sys.opera
  }
  if (Sys.safari) {
    Sys.name = 'Safari'
    Sys.version = Sys.safari
  }

  return Sys
}

function isBrowserOK() {
  const browser = browserCheck()
  if (browser.name === 'Chrome' || browser.name === 'Safari') {
    return '1'
  } else {
    return '0'
  }
}

function clearAllCookie() {
  var keys = document.cookie.match(/[^ =;]+(?==)/g)
  if (keys) {
    for (var i = keys.length; i--;) {
      if (['auto', 'username', 'password', 'identity'].indexOf(keys[i]) < 0) {
        setCookie(keys[i], '', -1)
      }
    }
  }
}

function getCookieValue(name) {
  let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  let arr = document.cookie.match(reg)
  if (arr) {
    return decodeURIComponent(arr[2])
  } else {
    return null
  }
}

function setCookie(name, value, days) {
  let cpUrl = window.ConfigNew ? window.ConfigNew.cpUrl : ''
  let zy = window.location.host.split('.').reverse()
  let cp = cpUrl
    .replace(/(http|https):\/\/([^/]*)\//g, '$2')
    .split('.')
    .reverse()
  let lgt = Math.min(zy.length, cp.length)
  let _domain = ''

  for (var i = 0; i < lgt; i++) {
    if (zy[i] === cp[i]) {
      _domain = '.' + zy[i] + _domain
    } else {
      break
    }
  }

  let expires
  if (days) {
    var date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toGMTString()
  } else {
    expires = ''
  }

  document.cookie = name + '=' + value + expires + '; path=/;domain=' + _domain
}

function writeLogParams(param) {
  let _param = ''
  if (getCookieValue('id')) {
    const browser = browserCheck()
    _param = Object.assign(
      {},
      {
        accessToken: getCookieValue('accessToken'),
        customerInfoId: getCookieValue('customerInfoId'),
        userId: getCookieValue('id'),
        userRoleType: getCookieValue('userRoleType'),
        actionOrigin: 1, // 动作来源 1.练习系统 2.测评系统 3内容系统 4.前端 等
        action: '', // 动作（操作）名称 标签 不超过
        pushParam: '', // 执行该动作（操作）的附加信息或者参数 如书本名称 建议json格式不超过255长度
        clientType: 1, // 客户端类型 0.未传或未知 1.Web 2.IOS 3.Android
        clientVersion: getCookieValue('clientVersion'),
        serverVersion: getCookieValue('serverVersion'),
        clientInfo: browser.name + ' ' + browser.version,
        userName: getCookieValue('username'),
        fullName: decodeURIComponent(getCookieValue('fullName')) || '',
        loginFrom: getCookieValue('loginFrom'),
        timestamp: Date.now(),
        logType: 1, // 日期类型 1正常日志 0异常日志
        schoolId: getCookieValue('schoolId') || '',
        categoryId: getCookieValue('categoryId') || '',
        scId: getCookieValue('classId') || '',
        resId: ''
      },
      param
    )
    _param.pushParam = JSON.stringify(_param.pushParam)
  } else if (localStorage.getItem('kami_track')) {
    const track = JSON.parse(localStorage.getItem('kami_track'))
    _param = Object.assign({}, track, param)
    _param.timestamp = Date.now()
    _param.fullName = decodeURIComponent(_param.fullName)
    _param.pushParam = JSON.stringify(_param.pushParam)
  } else {
    // TODO
  }

  return _param
}

let urlSet = {
  examReport: '/web/models/Report/default/self.php',
  rank: '/web/models/RankMessage/self.php'
}

function banBackSpace(e) {
  let ev = e || window.event
  // 各种浏览器下获取事件对象
  let obj = ev.relatedTarget || ev.srcElement || ev.target || ev.currentTarget
  // 按下Backspace键
  if (ev.keyCode === 8) {
    // 标签名称
    let tagName = obj.nodeName
    // 如果标签不是input或者textarea则阻止Backspace
    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
      ev.preventDefault()
      return
    }

    // 标签类型
    let tagType = obj.type.toUpperCase()
    // input标签除了下面几种类型，全部阻止Backspace
    if (
      tagName === 'INPUT' &&
      tagType !== 'TEXT' &&
      tagType !== 'TEXTAREA' &&
      tagType !== 'PASSWORD'
    ) {
      ev.preventDefault()
      return
    }

    // input或者textarea输入框如果不可编辑则阻止Backspace
    if (
      (tagName === 'INPUT' || tagName === 'TEXTAREA') &&
      (obj.readOnly === true || obj.disabled === true)
    ) {
      ev.preventDefault()
    }
  }
}

export default {
  osCheck,
  browserCheck,
  isBrowserOK,
  clearAllCookie,
  getCookieValue,
  setCookie,
  writeLogParams,
  urlSet,
  banBackSpace
}



// WEBPACK FOOTER //
// ./src/util/Util.js